export default "__VITE_ASSET__BpDI9l4p__"